// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_gcP","cls2":"ProfileDropdown-cls2_Jgb ProfileDropdown-cls1_gcP"};